"use client";
import { usePathname } from "next/navigation";
import Footer from "@/components/Footer";
import { HomeIcon, UserIcon, FolderIcon, CodeBracketIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import ThemeToggle from "@/components/ThemeToggle";
import { LazyFloatingDock, LazyChatBot, FloatingDockFallback, ChatBotFallback } from "@/components/ui/LazyLoad";

const navItems = [
  { title: "Home", href: "#", icon: <HomeIcon className="w-6 h-6" />, direction: "W", onClick: (e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); } },
  { title: "About", href: "#about", icon: <UserIcon className="w-6 h-6" />, direction: "NW" },
  { title: "Skills", href: "#skills", icon: <CodeBracketIcon className="w-6 h-6" />, direction: "N" },
  { title: "Projects", href: "#projects", icon: <FolderIcon className="w-6 h-6" />, direction: "NE" },
  { title: "Contact", href: "#contact", icon: <EnvelopeIcon className="w-6 h-6" />, direction: "E" },
];

export default function AppLayoutClient({ children }) {
  const pathname = usePathname();
  const isAdminPage = pathname.startsWith("/admin");
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
        const currentScrollY = window.scrollY;
        if (lastScrollY < currentScrollY && currentScrollY > 150) {
            setHidden(true);
        } else {
            setHidden(false);
        }
        lastScrollY = currentScrollY;
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (isAdminPage) {
    return <main className="w-full overflow-x-hidden">{children}</main>;
  }

  return (
    <div className="relative min-h-screen flex flex-col w-full overflow-x-hidden">
      {/* Theme Toggle in top right */}
      <div className="fixed top-4 right-4 z-50">
        <ThemeToggle />
      </div>
      
      {/* Floating Navigation Dock - Bottom of screen */}
      <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
        <LazyFloatingDock
          items={navItems}
          desktopClassName=""
          mobileClassName="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50"
          hidden={hidden}
        />
      </div>
      
      <LazyChatBot />
      <main className="flex-1 w-full overflow-x-hidden">{children}</main>
      <Footer />
    </div>
  );
}